import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const AccountDeletionRequestPage = () => {
  const { user, refreshUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleRequest = async () => {
    const confirmed = window.confirm('Hesap silme talebi olusturulsun mu? Onay gelmeden hesap silinmez.');
    if (!confirmed) return;

    try {
      setLoading(true);
      setMessage('');
      setError('');
      const data = await api.requestAccountDeletion();
      await refreshUser();
      setMessage(data.message || 'Hesap silme talebiniz alindi.');
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page analysis-page">
      <section className="hero-panel compact account-delete-hero">
        <div className="hero-copy">
          <span className="hero-badge">Hesap Silme</span>
          <h1>Hesap Silme Talebi</h1>
          <p>
            Tahmin Arena hesabinizi silmek istiyorsaniz asagidaki formu doldurarak talep olusturabilirsiniz.
          </p>
          <p>
            Talebiniz incelendikten sonra hesabiniz ve uygulama ici verileriniz silme surecine alinacaktir.
            Yasal yukumluluk gerektiren bazi kayitlar sinirli sureyle saklanabilir.
          </p>
          <p>Hesap silme talepleri genellikle 24-72 saat icinde sonuclandirilir.</p>
        </div>
      </section>

      <section className="content-panel">
        <div className="section-heading">
          <div>
            <h2>Talep Formu</h2>
            <p>Talep olusturulduktan sonra admin incelemesine gecer.</p>
          </div>
        </div>

        <div className="analysis-card account-delete-card">
          <div className="analysis-meta">
            <span>{user?.name}</span>
            <span>{user?.email}</span>
          </div>
          <div className="market-row">
            <button
              type="button"
              className="btn-primary"
              onClick={handleRequest}
              disabled={loading || user?.deletionRequestPending}
            >
              {user?.deletionRequestPending
                ? 'Silme Talebi Gonderildi'
                : loading
                  ? 'Gonderiliyor...'
                  : 'Hesap Silme Talebi Olustur'}
            </button>
          </div>
          {message ? <p className="analysis-summary">{message}</p> : null}
          {error ? <div className="error">{error}</div> : null}
        </div>
      </section>
    </div>
  );
};

export default AccountDeletionRequestPage;
